module.exports = __webpack_public_path__ + "static/media/edit_blue.2dd24277.svg";